import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc883cae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "order-preview"
}
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 1 ", -1))
const _hoisted_4 = {
  class: "contact-mycontainer table-responsive media-sm",
  style: {"margin-top":"16px","margin-bottom":"15px"}
}
const _hoisted_5 = { class: "table borderless" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, null, -1))
const _hoisted_7 = { class: "text-light-upper" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = { class: "text-light-upper" }
const _hoisted_10 = { class: "text-bold" }
const _hoisted_11 = { class: "text-light-upper" }
const _hoisted_12 = { class: "text-bold" }
const _hoisted_13 = { class: "text-light-upper" }
const _hoisted_14 = { class: "text-bold" }
const _hoisted_15 = { class: "text-light-upper" }
const _hoisted_16 = { class: "text-bold" }
const _hoisted_17 = { class: "text-light-upper" }
const _hoisted_18 = { class: "text-bold" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-light-upper" }
const _hoisted_21 = { class: "text-bold" }
const _hoisted_22 = { class: "text-light-upper" }
const _hoisted_23 = { class: "text-bold" }
const _hoisted_24 = { class: "title-bar" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 2 ", -1))
const _hoisted_26 = { class: "wakalah-mycontainer table-responsive media-sm" }
const _hoisted_27 = { class: "preview-footer" }
const _hoisted_28 = { class: "back-btn" }
const _hoisted_29 = { class: "payment-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_ctx.prevData.contactInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("prevTitle.value")), 1),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.$t("prevContactTitle.value")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t("fullname.value")), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.prevData.contactInfo.fullname), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t("mobilephone.value")), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.prevData.contactInfo.mobile), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t("wemail.value")), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.prevData.contactInfo.email), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t("country.value")), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.prevData.contactInfo.countryName), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t("city.value")), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.prevData.contactInfo.city), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t("town.value")), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.prevData.contactInfo.town), 1)
              ]),
              (_ctx.prevData.installment)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t("installmentPrice.value")), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.prevData.installment) + " 3 Taksıt", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t("prevtotal.value")), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.prevData.totalpayment), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("prevWakalahTitle.value")), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_BaseTable, {
            tableData: _ctx.prevData.wakalahList
          }, null, 8, ["tableData"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, [
            _createVNode(_component_BaseButton, {
              text: _ctx.$t('back.value'),
              onOnSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCancel')))
            }, null, 8, ["text"])
          ]),
          _createElementVNode("span", _hoisted_29, [
            _createVNode(_component_BaseButton, {
              text: _ctx.$t('payment.value'),
              onOnSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSubmit')))
            }, null, 8, ["text"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}